<template>
	<div>
		<div class="card card-default">
			<div class="card-header"><h6 class="float-left mb-0 font-weight-bold">Application History</h6></div>
			<div class="card-body table-responsive p-0" style="height: 335px;">
				<v-table :data="jobs" class="table table-head-fixed table-bordered table-hover" :currentPage.sync="currentPage" 
					:pageSize="5" @totalPagesChanged="totalPages = $event">
					<thead slot="head">
						<tr>
							<th>Employer</th>
							<th>Title(Position)</th>
							<th>Type</th>
							<th class="text-center" width="3%">Status</th>
							<th width="2%">&nbsp;</th>
						</tr>
					</thead>
					<tbody slot="body" slot-scope="{displayData}">
						<template v-if="!jobs.length">
							<tr>
								<td colspan="10" class="text-center py-4">
									<center><Stretch></Stretch></center>
								</td>
							</tr>
						</template>
						<template v-else>
							<tr v-for="job in displayData" :key="job.id">
								<td class="align-middle">
									<img :src="uploadPath+job.employer.photo_img" class="img-circle photo_img" />
									{{ job.employer.name }}
								</td>
								<td class="align-middle">
									<img :src="uploadPath+job.job_img" class="img-circle photo_img" />
									{{ job.title }}
								</td>
								<td class="align-middle">{{ job.job_type }}</td>
								<td class="align-middle text-center">
									<span class="badge badge-pill p-2" :class="{ 'badge-success': job.status==1, 'badge-dark': job.status==0}">
									{{ job.status==1 ? 'OPEN' : 'CLOSE' }}
								</span>
								</td>
								
								<td class="text-center align-middle">
									<router-link :to="`/job/${job.slug}`" class="text-primary">
										<i class="fas fa-arrow-right"></i>
									</router-link>
								</td>
							</tr>
							<tr v-if="displayData.length==0">
								<td colspan="10" class="text-center">No Jobs found</td>
							</tr>
						</template>
					</tbody>
				</v-table>


				<!-- <div class="row">
					<div class="col-md-12">
						{{ jobs }}
						<Stretch></Stretch>
						}
					</div>
				</div> -->
			</div>
			<div class="card-footer">
				<smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages" class="float-right pagination-sm custom-pagination" />
			</div>
		</div>
		</div>
	</div>
</template>
<script>

	import { mapGetters } from 'vuex'
	import {Stretch} from 'vue-loading-spinner'
	import moment from 'moment'

	export default {
		name: 'application-history',
		components: {
			Stretch
		},
		data() {
			return {
				uploadPath: '/images/uploads/',
				currentPage: 1,
				totalPages: 0,
				// filters: {
				// 	name: { value: '', keys: ['jobs.employer', 'title', 'type', 'industry'] }
				// },
				isLoading : false
			}
		},

		created() {
			this.$store.dispatch('fetchJobs');
		},
		computed: {
			...mapGetters(['jobs']),
		},
		methods: {
			json_parser(jsonData) {
				return JSON.parse(jsonData);
			},
			dateFormatter(data) {
				return moment(data).format("MMM DD, YYYY");
			},
			dateCounter(data) {
				return moment(data,"YYYYMMDD").fromNow();
			},
		}
	}
</script>

<style scoped>
	.photo_img {
		object-fit: cover;
		width: 32px;
		height: 32px;
	}
	.custom-pagination ul {
		margin-bottom: 0px !important;
	}
</style>